export enum NewsProvider {
    Passport = 'PASSPORT',
    Benzinga = 'BENZINGA',
}

export enum NewsBodyTypes {
    ImageSet = 'image_set',
    Text = 'text',
}

export interface NewsArticle {
    article_id: number;
    author: {
        avatar: string;
        biography: string;
        id: number;
        name: string;
    };
    body:
        | string
        | {
              type: NewsBodyTypes;
              body: string;
              main_image?: {
                  url: string;
              };
              data: NewsArticleData;
          }[];
    featured_image: {
        main_image: {
            url: string;
        };
        square_crop: {
            url: string;
        };
        rectangle_crop?: {
            url: string;
        };
        copyright?: string;
    };
    first_paragraph: string;
    long_summary: string;
    permalink: string | null;
    title: string;
    summary: string;
    tags: string[];
    release_date: string;
    symbols: string[];
    types: string[];
    url: string;
    provider: NewsProvider;
    news_item_id?: number;
    headline?: string;
    createdOn?: string;
    xmlBody?: string;
    firstLink?: string;
    data?: NewsArticleData;
}

export interface NewsArticleData {
    [key: number]: {
        type: NewsArticleDataType;
        value: string;
    };
}
enum NewsArticleDataType {
    Stock = 'stock',
    Article = 'article',
}

export enum PassportNewsTypes {
    SectorNews = 'Sector News ',
    EarningsNews = 'Earnings News ',
    CompanyProfile = 'company profiles',
}

export enum PassportNewsTags {
    MarketUpdate = 'market summary',
    Etf = 'ETF',
    Earnings = 'earnings',
    IPO = 'IPO',
}

export enum PassportAvailableLanguages {
    English = 'eng',
    Polish = 'pol',
    Chinese = 'chn',
}

export interface HoopsAiMetaData {
    generation_utc_date: string;
    generation_run_time: unknown;
    customer_name: string;
    content_type: string;
    doc_structure: string;
    doc_structure_score: number;
    header: string;
    snippets_dict: unknown;
    asset_quote: {
        timestamp: string;
        open: number;
        previous_close: number;
        close: number;
        high: number;
        low: number;
    };
    target_symbols_quotes_list: HoopsAiPortfolioSymbolsQuoteList[];
}

export interface HoopsAiArticle {
    content: string;
    header: string;
    image_url: string;
    text: string;
    metadata?: HoopsAiMetaData;
}

export interface HoopsAiArticleWithExtraInfo extends HoopsAiArticle {
    id: string;
}

export interface HoopsAiPortfolioSymbolsQuoteList {
    symbol: string;
    name: string;
    price: number;
    changesPercentage: number;
    change: number;
    dayLow: number;
    dayHigh: number;
    yearHigh: number;
    yearLow: number;
    marketCap: number;
    priceAvg50: number;
    priceAvg200: number;
    volume: number;
    avgVolume: number;
    exchange: string;
    open: number;
    previousClose: number;
    eps: number;
    pe: number;
    earningsAnnouncement: string;
    sharesOutstanding: number;
    date: string;
    asset_class: string;
}

export interface InsightNewsTaxonomy {
    code: string;
    name: string;
    subcodes: {
        code: string;
        name: string;
    }[];
}
